import { render } from "./SpeakingReview.vue?vue&type=template&id=55c7adcc&scoped=true"
import script from "./SpeakingReview.vue?vue&type=script&lang=js"
export * from "./SpeakingReview.vue?vue&type=script&lang=js"

import "./SpeakingReview.vue?vue&type=style&index=0&id=55c7adcc&scoped=true&lang=css"

import exportComponent from "/vercel/path0/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55c7adcc"]])

export default __exports__